import { useState, useContext, Fragment, useEffect } from 'react';
import { AppContext } from '../../core/Contexts/AppContext';

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  const faqs = [
    {
      question:
        'რომელ საიტზე იტვირთება პროდუქტის იმპორტის წინასწარი შეტყობინება?',
      answer:
        ' წინასწარი შეტყობინება საჭიროა აიტვირთოს სსიპ შემოსავლების სამსახურის საიტზე  https://www.rs.ge/ .',
    },
    {
      question:
        ' როგორ ვიპოვო საიტზე https://www.rs.ge/ განცხადების ასატვირთი გვერდი? ',
      answer:
        'საიტზე საჭიროა ავტორიზაციის გავლის შემდეგ ამოირჩიოთ საქართველოს ეკონომიკისა და მდგრადი განვითარების ბმული და შემდეგ მიჰყვეთ ინსტრუქციას . (ერთობლივი ბრძანება №224/№1-1/349) ',
    },
    {
      question: ' რა ვადაში გაეცემა პასუხი ატვირთულ წინასწარ შეტყობინებას? ',
      answer:
        ' პასუხი გაეცემა განცხადების ატვირთვიდან შემდგომი 3 (სამი) სამუშაო დღის მანძილზე, გარდა იმ შემთხვევებისა, როდესაც პროდუქტის შეაბამისობის დასადგენად აუცილებელია ლაბორატორიული კვლევა. ',
    },
    {
      question:
        ' თუ არის რაიმე საშუალება განცხადების პასუხის დასაჩქარებლად ( ფასიანი სერვისი)? ',
      answer:
        '  ამ ეტაპზე განაცხადის ატვირთვიდან შემდგომი 3 (სამი) სამუშაო დღის პერიოდია პასუხის გაცემისათვის. ',
    },
    {
      question:
        '  არის თუ არა შესაძლებელი პროდუქტის შეძენამდე წინასწარ აიტვირთოს საიტზე https://www.rs.ge/  შესაძენი პროდუქტის დოკუმენტაცია?',
      answer:
        ' დაშვებულია მხოლოდ შეძენილი პროდუქციის დოკუმენტაციის ატვირთვა.   ',
    },
    {
      question: '  რა შემთხევაში უტარდება ლაბორატორიული კვლევა პროდუქციას?  ',
      answer:
        '  იმ შემთხვევაში, თუ პროდუქტის შესაბამისობის დასადგენად საჭიროა ლაბორატორიული კვლევა სააგენტო უფლებამოსილია, საქართველოს საბაჟო კონტროლის ზონაში აიღოს პროდუქტის ნიმუში, მისი შესაბამის აკრედიტებულ ლაბორატორიაში გამოცდის მიზნით.  ',
    },
    {
      question:
        ' რა ტიპის სათამაშოებზე არ ვრცელდება ტექნიკური რეგლამენტის მოქმედება? ',
      answer:
        '  ტექნიკური რეგლამენტის მოქმედება არ ვრცელდება: საჯარო გამოყენებისათვის განკუთვნილი სათამაშო მოედნების მოწყობილობებზე, მონეტებზე ან მათ გარეშე მომუშავე ავტომატურ სათამაშო მანქანებზე, რომლებიც განკუთვნილია საჯარო გამოყენებისთვის, წვის ძრავით აღჭურვილ სათამაშო მანქანებზე, სათამაშო ორთქლის ძრავებზე, შურდულებზე და კატაპულტებზე და აშ. ',
    },
    {
      question: '  რა დოკუმენტაციაა წარსადგენი სათამაშოს შემთხვევაში? ',
      answer:
        '  სათამაშოს შემთხვევაში წარსადგენია შესაბამისობის დეკლარაცია , რომელიც მწარმოებლის მიერ შედგენილი დოკუმენტია.  ',
    },

    {
      question: ' რა ენაზე უნდა იყოს წარმოდგენილი დოკუმენტაცია ? ',
      answer:
        '  შესაბამისობის დამადასტურებელი დოკუმენტები წარმოდგენილი უნდა იყოს ქართულ ან ინგლისურ ენაზე, თარგმნის შემთხვევაში დოკუმენტი უნდა იყოს ნოტარიულად დამოწმებული. ხოლო ინსტრუქციები, უსაფრთხო მოხმარების წესები და გამაფრთხილებელი ნიშნები უნდა იყოს ქართულ ენაზე. ',
    },
    {
      question:
        '  სათამაშოს შემთხვევაში, რას მოიცავს ძირითადი უსაფრთხოების ნორმები?',
      answer:
        ' დაუშვებელია სათამაშო უქმნიდეს საფრთხეს ადამიანის სიცოცხლეს და ჯანმრთელობას. სათამაშო და მისი ნაწილები საჭიროა გამორიცხავდეს გაგუდვის რისკს, ხმა აზიანებდეს ბავშვის სმენას. დაუშვებელია ქმნიდეს ცეცხლის გაჩენის რისკს, ასევე შეიცავდეს ალერგიის გამომწვევ არომატულ ნივთიერებებს.  ',
    },
    {
      question:
        ' რამდენი ვოლტია დასაშვები ელექტრული თვისებების მქონე სათამაშოებზე? ',
      answer:
        '  მაქსიმალურად დასაშვებია 24 ვოლტი. გარდა ამისა, ელექტრული სათამაშოს ხელმისაწვდომი ზედაპირი დაუშვებელია ცხელდებოდეს ისეთ ტემპერატურაზე, რომელსაც შეუძლია შეხებისას დამწვრობის გამოწვევა. ასევე, კაბელები და სხვა ელექტროგამტარები, რომელთა გავლითაც მსგავს ნაწილებამდე ელექტროენერგიის მიწოდება ხდება, უნდა იყოს სათანადოდ იზოლირებული და მექანიკურად დაცული რათა თავიდან იქნეს აცილებული ელექტროშოკის რისკი. ',
    },
    {
      question:
        '  რა აუცილებელ ინფორმაციას უნდა შეიცავდეს შესაბამისობის დეკლარაცია სათამაშოს შემთხვევაში?',
      answer:
        ' აუცილებელია შესაბამისობის დეკლარაციაში იყოს სათამაშოს საიდენტიფიკაციო ნომერი, მწარმოებლის დასახელება, მისამართი, სათამაშოს ფერადი სურათი, მითითება გამოყენებულ სტანდარტებსა და ტექნიკურ რეგლამენტზე, რომელთან შესაბამისობაშიც არის სათამაშო, შესაბამისობის შემფასებელი ორგანოს დასახელება (ასეთის არსებობის შემთხვევაში), გაცემული სერტიფიკატის ნომერი, სხვა ინფორმაცია, პასუხისმგებელი პირის ხელმოწერა და თარიღი. ',
    },

    {
      question:
        ' დამატებით რა რეგულაციები ვრცელდება 36 თვემდე ასაკის ბავშვების სათამაშოებზე? ',
      answer:
        '  36 თვემდე ბავშვებისთვის გნკუთვნილი სათამაშოც ისევე უნდა აკმაყოფილდებეს სათამაშოების უსაფრთხოების შესახებ ტექნიკური რეგლამენტის მოთხოვნებს, როგორც სხვა ნებისმიერი სათამაშო. უნდა ჰქონდეს შესაბამისობის დეკლარაცია, დატანილი უნდა იყოს მწარმოებლის და იმპორტიორის მონაცემები, ინსტრუქციები და გამაფრთხიელებლი ნიშნები დატანილი უნდა იყოს ქართულ ენაზე, ამასთანავე მსგავს სათამაშოები სტანდარტის შესაბამისად, არ უნდა შეიცავდეს მცირე ზომის ნაწილებს. ',
    },
    {
      question:
        '  არის თუ არა შესაძლებელი ატვირთული დოკუმენტაციის კორექტირება?',
      answer:
        ' საჭიროა თავიდან აიტვირთოს დოკუმენტაცია, ატვირთული დოკუმენტაცია კორექტირებას არ ექვემდებარება. ',
    },

    {
      question:
        'ვრცელდება თუ არა დადგენილება N47(სათამაშოების უსაფრთხოების შესახებ ტექნიკური რეგლამენტის დამტკიცების თაობაზე) იმპორტირებულ მეორად სათამაშოებზე? ',
      answer:
        '  ტექნიკური რეგლამენტი სათამაშოების უსაფრთხოების შესახებ ვრცელდება ყველა იმ სათამაშოზე, რომელთა განთავსება ხდება საქართველოს ბაზარზე, მათ შორის მეორეულ სათამაშეობზეც. თუმცა, თუ მეორეული სათამაშო იყო განკუთვნილი ან განთავსებული საქათველოს მთავრობის 50-ე დადგენილებით განსაზღვრული ქვეყნებიდან რომელიმეს ბაზრზე სათამაშოების უსაფრთხოების შესახებ ტექნიკური რეგლამენტის მიხედვით შესაბამისობის დეკლარაციის ნაცვლად წარმოდგენილი უნდა იყოს მეორეულობის დამადასტურებელი დოკუმენტი და სატრანსპორტო დოკუმენტი. ',
    },
    {
      question:
        ' რა დოკუმენტაცია არის წარსადგენი საიტზე https://msa.gov.ge/ იმ შემთხვევაში,თუ შემოსავლების სამსახური ითხოვს დასტურს, სსიპ ბაზარზე ზედამხედველობის სააგენტოსგან, რომ პროდუქტზე არ ვრცელდება ტექნიკური რეგლამენტის რეგულაციები?',
      answer:
        ' შემოსავლების სამსახურის საიტზე განცხადების შევსებისას მომხმარებელმა უნდა იხელმძღვანელოს პროდუქტის დასახელებით და დანართებსა და პროგრამაში მოიძიოს ის კოდი, რომელიც პროდუქტის დასახელებასთან არის დაკავშირებული. იმ შემთხვევაში, თუ პროდუქტს კოდი პირდაპირ არ მიესადაგება, უნდა ავირჩიოთ ის კოდი და დასახელება, რომელიც ყველაზე მეტად არის დაკავშირებული პროდუქტთან. ',
    },

    {
      question:
        'როგორ შევხვდეთ დამატებითი ინფორმაციის მისაღებად სააგენტოს თანამშრომლებს? ',
      answer:
        '  საჭიროა მეილზე info@msa.gov.ge დაფიქსირდეს თხოვნა შეხვედრასთან დაკავშირებით და პასუხად გეცნობებათ შეხვედრის ზუსტი თარიღი და დრო. ',
    },
    {
      question:
        ' კონკრეტულად რა ტიპის სამშენებლო პროდუქტები ექცევა ტექნიკური რეგლამენტის რეგულირების სფეროში?',
      answer:
        ' სამშენებლო პროდუქტების შესახებ ტექნიკური რეგლამენტის მოქმედება ვრცელდება ხუთ სამშენებლო პროდუქტზე, ესენია: ცემენტი, არმატურა, ელექტრო კაბელი, პლასტმასის მილი და თაბაშირ მუყაო. ',
    },
  ];

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    setTitle('FAQ');
    setImage('../../images/contact_us.jpg');
    setHeaderType(1);
  }, []);

  return (
    <Fragment>
      <section>
        <div className='container'>
          <h2 className='bold font__size--32 text__32-1024 mb-3 text-uppercase'>
            FAQ
          </h2>
          <div className='accordion' id='faqAccordion'>
            {faqs.map((faq, index) => (
              <div key={index} className='accordion-item mb-3'>
                <h4 className='accordion-header'>
                  <button
                    className={`accordion-button ${
                      activeIndex === index ? '' : 'collapsed'
                    }`}
                    type='button'
                    onClick={() => handleAccordionClick(index)}
                    aria-expanded={activeIndex === index}
                  >
                    <span>{faq.question}</span>
                    <span
                      className={`arrow-icon ${
                        activeIndex === index ? 'rotate' : ''
                      }`}
                    >
                      ↓
                    </span>
                  </button>
                </h4>
                <div
                  className={`accordion-collapse collapse ${
                    activeIndex === index ? 'show' : ''
                  }`}
                >
                  <div className='accordion-body wrapper__list-document'>
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Faq;
